// Mirrors backend/utils/lyrics_schema.py.

const CONTROL_CHARACTERS = /[\u0000-\u001f\u007f-\u009f]/g;

export const EMPTY_LYRICS = Object.freeze({
  version: 1,
  title: '',
  style: '',
  cadence: [],
  sections: [],
});

function cleanString(value, max, field) {
  if (typeof value !== 'string') throw new Error(`Invalid ${field}`);
  const cleaned = value.replace(CONTROL_CHARACTERS, '').trim();
  if (cleaned.length > max) throw new Error(`Invalid ${field}`);
  return cleaned;
}

function optionalId(value, field) {
  if (value == null) return null;
  return cleanString(value, 64, field);
}

export function normalizeLyrics(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value) || value.version !== 1) {
    throw new Error('Invalid lyrics data');
  }
  const cadenceInput = value.cadence ?? [];
  const sectionsInput = value.sections ?? [];
  if (!Array.isArray(cadenceInput) || cadenceInput.length > 7) throw new Error('Invalid cadence');
  if (!Array.isArray(sectionsInput) || sectionsInput.length > 8) throw new Error('Invalid sections');

  let lineCount = 0;
  const sections = sectionsInput.map((section) => {
    if (!section || typeof section !== 'object' || Array.isArray(section)) {
      throw new Error('Invalid section');
    }
    const linesInput = section.lines ?? [];
    if (!Array.isArray(linesInput) || linesInput.length > 16) throw new Error('Invalid lines');
    lineCount += linesInput.length;
    const normalized = {
      id: optionalId(section.id, 'section id'),
      marker_id: optionalId(section.marker_id, 'marker id'),
      label: cleanString(section.label, 30, 'section label'),
      lines: linesInput.map((line) => {
        if (!line || typeof line !== 'object' || Array.isArray(line)) {
          throw new Error('Invalid line');
        }
        return { text: cleanString(line.text, 140, 'line text') };
      }),
    };
    if (normalized.id === null) delete normalized.id;
    if (normalized.marker_id === null) delete normalized.marker_id;
    return normalized;
  });
  if (lineCount > 48) throw new Error('Invalid lyric line count');

  return {
    version: 1,
    title: cleanString(value.title ?? '', 80, 'title'),
    style: cleanString(value.style ?? '', 400, 'style'),
    cadence: cadenceInput.map((entry) => {
      if (!entry || typeof entry !== 'object' || Array.isArray(entry)) {
        throw new Error('Invalid cadence entry');
      }
      return {
        label: cleanString(entry.label, 20, 'cadence label'),
        note: cleanString(entry.note, 160, 'cadence note'),
      };
    }),
    sections,
  };
}

export function emptyLyrics() {
  return { version: 1, title: '', style: '', cadence: [], sections: [] };
}

export function safeLyrics(value) {
  try {
    return normalizeLyrics(value);
  } catch (error) {
    return emptyLyrics();
  }
}
